// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lj-3";
export var downloadButton = "_lj-4";
export var fileContainer = "_lj-9 _lj-7";
export var fileContainerBase = "_lj-7";
export var fileContainerFixedHeight = "_lj-8 _lj-7";
export var fileInfo = "_lj-5";
export var fileInfoWidthRestricted = "_lj-6";
export var fileType = "_lj-1";
export var fileTypeName = "_lj-2";
export var image = "_lj-0";
export var link = "_lj-b";
export var overflowEllipsis = "_lj-a";